const Cookie = require('Vendor/js-cookie');

module.exports = AppSmartBanner;

function AppSmartBanner() {
	const banner = $("#smart-banner");

	banner.on("click", () => {
		console.log("AppSmartBanner.clickSmartBanner()");
		banner.collapse();
		Cookie.set('hide-donate-smart-banner', true, {expires:365});
	});
}